import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import { LeadSelectionList } from './LeadSelectionList';
import { Lead } from '../redux/slices/leadSlice';

interface LeadSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onSelectLead: (leads: Lead[]) => void;
}

const LeadSelectionDialog: React.FC<LeadSelectionDialogProps> = ({
  open,
  onClose,
  onSelectLead,
}) => {
  const [selectedLeads, setSelectedLeads] = useState<Lead[]>([]);

  const handleSelectLead = (leads: Lead[]) => {
    console.log(`Dialog: ${leads.length} leads selecionados`);
    console.log('Dialog: Leads selecionados:', leads.map(lead => `${lead.name} (${lead.email})`));
    setSelectedLeads(leads);
  };

  const handleConfirmSelection = () => {
    onSelectLead(selectedLeads);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Selecionar Leads</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <LeadSelectionList onSelectLead={handleSelectLead} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirmSelection}
          disabled={selectedLeads.length === 0}
        >
          Confirmar Seleção ({selectedLeads.length})
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadSelectionDialog; 